<template>
  <div class="content">
    <div class="container-fluid">
    </div>
  </div>
</template>

<script>
  export default {
  }
</script>